document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.tny-pp');

  sections.forEach(function (root) {
    // Gallery thumbnail swap
    var mainImg = root.querySelector('.tny-pp__main-image img');
    var thumbs = root.querySelectorAll('.tny-pp__thumb');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute('data-full');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Quantity stepper
    var qtyInput = root.querySelector('.tny-pp__qty-input');
    var minusBtn = root.querySelector('[data-qty-minus]');
    var plusBtn = root.querySelector('[data-qty-plus]');

    if (qtyInput && minusBtn && plusBtn) {
      minusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
      plusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }
  });
});